<script>
    export default {
        name: 'Modal',

        data() {
            return {
                showing: false,
            };
        },

        created() {
            this.$on('open', this.open);
            this.$on('close', this.close);
        },

        methods: {
            open() {
                if (!this.showing) {
                    this.showing = true;
                    this.$emit('opened');
                }
            },
            close() {
                if (this.showing) {
                    this.showing = false;
                    this.$emit('closed');
                }
            },
        },
    };
</script>

<template>
    <div>
        <transition
            enter-active-class="transition-all duration-200 ease-out"
            leave-active-class="transition-all duration-300 ease-in"
            enter-class="opacity-0 scale-70"
            enter-to-class="opacity-100 scale-100"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-70"
        >
            <div @click.self="close" v-show="showing"
                 class="fixed inset-0 z-50 w-full min-h-screen flex justify-center sm:items-center bg-black bg-opacity-50">
                <div class="relative overflow-auto w-full lg:max-w-4xl">
                    <div class="m-2">
                        <div class="bg-white text-green rounded-lg">
                            <!-- Modal Heading -->
                            <div class="relative border-b border-green">
                                <div class="flex flex-row justify-between items-center px-6 py-3">
                                    <div class="font-title text-2xl uppercase">
                                        <slot name="title"></slot>
                                    </div>

                                    <svg class="w-6 h-6 cursor-pointer" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24"
                                         xmlns="http://www.w3.org/2000/svg"
                                         @click.prevent="close">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </div>
                            </div>

                            <!-- Modal Body -->
                            <div class="relative bg-white text-green text-body text-sm  rounded-b-lg">
                                <div class="p-6">
                                    <slot></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
